<template>
	<div class="age-legend">
		<span class="ringworm">R</span>
		<span v-for="(age, index) in ages" :key="index"><Age :year="age.year"/></span>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import Age from '../Common/Age'
export default {
	components: {
		Age
	},
	computed : {
		...mapState({
			ages: state => state.age.list
		})
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		const ages = this.$store.dispatch('age/getList')

		Promise.all([ages])
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">
.age-legend {
	.ringworm {
		display: inline-block;
		background: #F7402D;
		border-radius: 4px;
		margin-bottom: 14px;
		width: 40px;
		color: white;
		line-height: 32px;
		text-align: center;
	}
	span {
		display: inline-block;
		width: 40px;
		margin-right: 20px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Board/AgeLegend.vue